export default __webpack_public_path__ + "static/assets/SL-X-teal-light.1ce64a2f.png";